module.exports = __webpack_public_path__ + "img/reject-icon.25882bc9.svg";